import React, { useState } from 'react'
import PropTypes from 'prop-types'

import axios from '../../dataClient/dataClient'
import { downloadZipFile, getFile } from '../../util/downloadFile'
import { ErrorText } from '../styles/Text'
import Button from './Button'

function DownloadResponseButton({ requestType, requestId, secondaryId, label = 'Download Response', fileList = [], letter }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()

  async function downloadResponsePackage() {
    setLoading(true)
    setError(false)

    try {
      const files = []
      let fileError = false

      for (const f of fileList) {
        try {
          const response =
            requestType === 'foi'
              ? await axios.get(`/file/${f.id}/download`, { responseType: 'blob' })
              : await axios.get(`/download/${requestId}/${encodeURIComponent(f.name)}`, { responseType: 'blob' })
          const file = getFile(response, requestType === 'foi' ? f.filename : f.name)
          files.push(file)
        } catch (e) {
          fileError = true
          const fileName = requestType === 'foi' ? f.filename : f.name
          console.error(`An error occurred while downloading the file %s for %s with ID %s`, fileName, requestType.toUpperCase(), requestId, e)
        }
      }

      if (letter) {
        try {
          const response = await axios.get(`/letter/${letter.id}/download`, { responseType: 'blob' })
          const file = getFile(response, `${letter.name}.pdf`)
          files.push(file)
        } catch (e) {
          fileError = true
          console.error(`An error occurred while downloading the letter %s for %s with ID %s`, letter.name, requestType.toUpperCase(), requestId, e)
        }
      }

      if (!fileError) downloadZipFile(files, `${secondaryId}.zip`)
      else setError(true)
    } catch (e) {
      console.error('Failed to build response package zip.', e)
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Button onClick={downloadResponsePackage} loading={loading}>
        {label}
      </Button>
      {error && <ErrorText role="alert">There was an error downloading the files. Please try again.</ErrorText>}
    </>
  )
}

DownloadResponseButton.propTypes = {
  requestType: PropTypes.oneOf(['foi', 'pir']).isRequired,
  requestId: PropTypes.string.isRequired,
  secondaryId: PropTypes.string.isRequired,
  label: PropTypes.string,
  fileList: PropTypes.array,
  letter: PropTypes.object
}

export default DownloadResponseButton
